import { Component, ElementRef, Input } from '@angular/core';
import {
    ItemsListContentBaseComponent,
    ItemsListContentBaseComponent_processRowChecked,
    ItemsListContentBaseComponent_settings,
} from './content-base/content-base.component';
import { ItemsListContentListViewComponent } from './content-list-view/content-list-view.component';
import { ItemsListContentGridViewComponent } from './content-grid-view/content-grid-view.component';
import { ItemsListContentListViewWithChildrenComponent } from './content-list-view-with-children/content-list-view-with-children.component';
import { ItemsListContentGridViewWithChildrenComponent } from './content-grid-view-with-children/content-grid-view-with-children.component';
import { Subject } from 'rxjs';
import { FiDisplayType } from '@fi-shared/types/display-type';

@Component({
    selector: 'fi-items-list-content',
    template: '<ng-container *ngComponentOutlet="getComponentType()"></ng-container>',
    styleUrls: ['./list-content.component.scss'],
    providers: [
        {
            provide: ItemsListContentBaseComponent_settings,
            useFactory: (instance: ItemsListContentComponent) => instance.ngModel,
            deps: [ItemsListContentComponent],
        },
        {
            provide: ItemsListContentBaseComponent_processRowChecked,
            useFactory: (instance: ItemsListContentComponent) => instance.processRowsChecked$,
            deps: [ItemsListContentComponent],
        },
    ],
    standalone: false,
})
export class ItemsListContentComponent {
    @Input('settings') ngModel;
    @Input() displayType: FiDisplayType;

    constructor(public elementRef: ElementRef) {}

    public getComponentType(): any | ItemsListContentBaseComponent {
        if (this.ngModel.listContentComponent) return this.ngModel.listContentComponent;

        switch (this.displayType) {
            case FiDisplayType.List:
                return this.ngModel.ChildProperty
                    ? ItemsListContentListViewWithChildrenComponent
                    : ItemsListContentListViewComponent;
            case FiDisplayType.Grid:
                return this.ngModel.ChildProperty
                    ? ItemsListContentGridViewWithChildrenComponent
                    : ItemsListContentGridViewComponent;
        }
    }

    processRowsChecked$ = new Subject<void>();
    processRowsChecked() {
        this.processRowsChecked$.next();
    }
}
